import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { queries } from '../../graphql/graphql';
import { Button, Menu, Dropdown } from 'antd';

export const SelectTemplate = ({ onChange, value }) => {
  const { data = {} } = useQuery(queries.TEMPLATES);
  const { templates = [] } = data;
  const menu =
    templates &&
    templates.map(item => (
      <Menu.Item key={item.id} onClick={() => onChange(item.id)}>
        {item.title}
      </Menu.Item>
    ));
  return (
    <>
      <Dropdown
        overlay={<Menu style={{ scroll: 'auto' }}>{menu}</Menu>}
        placement="bottomLeft"
        arrow
      >
        <Button>Select typeform</Button>
      </Dropdown>
      <div>{value}</div>
    </>
  );
};
